module.exports = __webpack_public_path__ + "img/quickApplicationIcon.495721cd.png";